import Vue from "vue";
import App from "./App.vue";
import DesktopNotification from "./plugins/notification";
import router from "./router";
import { Auth0Plugin } from "./auth";
import store from "./store";
import ConveyApi from "./apis";

import hljs from "highlight.js/lib/core";
import "highlight.js/styles/github.css";
Vue.use(hljs.vuePlugin);

import Notifications from "vue-notification";
Vue.use(Notifications);
import Toaster from "./plugins/toaster";
Vue.use(Toaster);

import VueMasonry from "vue-masonry-css";
Vue.use(VueMasonry);

import VueFeather from "vue-feather";
Vue.use(VueFeather);

import VueMask from "v-mask";
Vue.use(VueMask);

import LazyLoadDirective from "./directives/LazyLoadDirective";
Vue.directive("lazyload", LazyLoadDirective);

import IndicatorDirective from "./directives/indicator";
Vue.directive("indicator", IndicatorDirective);

var VueCookie = require("vue-cookie");
Vue.use(VueCookie);

import * as VueGoogleMaps from "vue2-google-maps";

Vue.config.productionTip = false;

Vue.prototype.$apihost =
  (process.env.VUE_APP_API_URI ? process.env.VUE_APP_API_URI : "") +
  (process.env.VUE_APP_API_BASE_PATH
    ? process.env.VUE_APP_API_BASE_PATH
    : "/api/v1");
if (process.env.VUE_APP_SOCKET_URI)
  Vue.prototype.$wshost = process.env.VUE_APP_SOCKET_URI;

Vue.prototype.$baseuri = process.env.VUE_APP_BASE_URI;
Vue.prototype.$basescheme = process.env.VUE_APP_BASE_SCHEME;
Vue.prototype.$apptitle = process.env.VUE_APP_TITLE;
Vue.prototype.$ConveyApi = ConveyApi;

Vue.use(VueGoogleMaps, {
  load: {
    key: process.env.VUE_APP_GOOGLE_API_KEY,
    libraries: "places",
  },
});

import VueGeolocation from "vue-browser-geolocation";
Vue.use(VueGeolocation);

import { library } from "@fortawesome/fontawesome-svg-core";
import {
  faLink,
  faUser,
  faPowerOff,
  faCaretDown,
  faCaretRight,
  faCaretLeft,
  faUserCircle,
  faCog,
  faInfo,
  faInfoCircle,
  faPaperPlane,
  faImage,
  faSmileBeam,
  faCheckCircle,
  faPlus,
  faMinus,
  faPlay,
  faRedoAlt,
  faUndoAlt,
  faShare,
  faReply,
  faArrowsAltH,
  faArrowsAltV,
  faChevronLeft,
  faChevronRight,
  faStop,
  faPause,
  faDownload,
  faVolumeDown,
  faVolumeUp,
  faVolumeOff,
  faCode
} from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/vue-fontawesome";

library.add(
  faLink,
  faUser,
  faPowerOff,
  faCaretDown,
  faCaretRight,
  faCaretLeft,
  faUserCircle,
  faCog,
  faInfo,
  faInfoCircle,
  faPaperPlane,
  faImage,
  faSmileBeam,
  faCheckCircle,
  faPlus,
  faMinus,
  faPlay,
  faRedoAlt,
  faUndoAlt,
  faShare,
  faReply,
  faArrowsAltH,
  faArrowsAltV,
  faChevronLeft,
  faChevronRight,
  faStop,
  faPause,
  faDownload,
  faVolumeDown,
  faVolumeUp,
  faVolumeOff,
  faCode
);
Vue.component("font-awesome-icon", FontAwesomeIcon);

import { BootstrapVue, IconsPlugin } from "bootstrap-vue";
import "bootstrap-vue/dist/bootstrap-vue.css";

Vue.use(BootstrapVue);
Vue.use(IconsPlugin);

const domain = process.env.VUE_APP_AUTH0_DOMAIN;
const clientId = process.env.VUE_APP_AUTH0_CLIENT_ID;
const audience = process.env.VUE_APP_AUTH0_API_AUDIENCE;

Vue.use(Auth0Plugin, {
  domain,
  clientId,
  audience,
  onRedirectCallback: (appState) => {
    router.push(
      appState && appState.targetUrl
        ? appState.targetUrl
        : window.location.pathname
    );
  },
  store: store,
});

Vue.use(DesktopNotification);

// import { Configuration, OpenAIApi } from "openai";
// const openAIConfig = new Configuration({
//   apiKey: process.env.VUE_APP_OPENAI_API_KEY
// });
// Vue.prototype.$openai = new OpenAIApi(openAIConfig);

import { vfmPlugin } from "vue-final-modal";

Vue.use(
  vfmPlugin({
    key: "$vfm",
    componentName: "VueFinalModal",
    dynamicContainerName: "ModalsContainer",
  })
);

import VueTippy from "vue-tippy";
import "tippy.js/themes/light.css";
Vue.use(VueTippy);

import LoadScript from "vue-plugin-load-script";
Vue.use(LoadScript);

new Vue({
  store,
  router,
  render: (h) => h(App),
}).$mount("#app");
